export default "__VITE_ASSET__CdjhZf06__"